/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Form } from '../components/Form';
import { useHtmlField } from '../hooks/useHtmlField';
import { useCallback } from 'react';
import { FormGroup } from '../components/FormGroup';
import { TextField } from '../components/TextField';
import { Button } from '../components/Button';
import { validateAll } from '../util/validateAll';
import { useQueryString } from '../hooks/useQueryString';
import { passwordComplexity } from '../validators/passwordComplexity';
import { required } from '../validators/required';
export var SetPasswordForm = function (_a) {
    var className = _a.className, onSubmit = _a.onSubmit, busy = _a.busy, showName = _a.showName;
    var token = useQueryString('token');
    var password = useHtmlField('', passwordComplexity);
    var name = useHtmlField('', required);
    var passwordsMustMatch = useCallback(function (value) {
        return value !== password.value ? 'Enter the same value as above' : null;
    }, [password.value]);
    var confirmPassword = useHtmlField('', passwordsMustMatch);
    var _onSubmit = function () {
        var fields = [password, confirmPassword];
        if (showName) {
            fields.push(name);
        }
        if (!validateAll(fields)) {
            return;
        }
        onSubmit(token, password.value, name.value);
    };
    return (jsx(Form, { className: className, onSubmit: _onSubmit },
        showName && (jsx(FormGroup, { label: "Name", error: name.error, controlId: "name" },
            jsx(TextField, { type: "text", placeholder: "Joe Bloggs", value: name.value, onChange: name.onChange, onBlur: name.validate, variant: name.error ? 'error' : 'default', id: "name" }))),
        jsx(FormGroup, { label: "Password", error: password.error, controlId: "password" },
            jsx(TextField, { type: "password", placeholder: "Type at least 8 characters", value: password.value, onChange: password.onChange, onBlur: password.validate, variant: password.error ? 'error' : 'default', id: "password" })),
        jsx(FormGroup, { label: "Confirm password", error: confirmPassword.error, controlId: "confirmPassword" },
            jsx(TextField, { type: "password", placeholder: "Type it again to guard against mistakes", value: confirmPassword.value, onChange: confirmPassword.onChange, onBlur: confirmPassword.validate, variant: confirmPassword.error ? 'error' : 'default', id: "confirmPassword" })),
        jsx(Button, { variant: "primary", type: "submit", busy: busy, sx: { mt: 3 } }, "Set password")));
};
//# sourceMappingURL=SetPasswordForm.js.map